"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekIdentifier = void 0;
const types_1 = require("@hoepel.app/types");
const date_fns_1 = require("date-fns");
const locale_1 = require("date-fns/locale");
class WeekIdentifier {
    constructor(_year, _weekNumber) {
        this._year = _year;
        this._weekNumber = _weekNumber;
    }
    get value() {
        return `${this.year}-${this.weekNumber}`;
    }
    get range() {
        const dateZero = new Date(0);
        const week = date_fns_1.setWeek(date_fns_1.setYear(date_fns_1.setDay(dateZero, 2, { locale: locale_1.nlBE }), this.year), this.weekNumber, { locale: locale_1.nlBE });
        const start = date_fns_1.startOfWeek(week, { locale: locale_1.nlBE });
        const end = date_fns_1.endOfWeek(week, { locale: locale_1.nlBE });
        return new types_1.DayDateRange({
            from: types_1.DayDate.fromNative(start),
            to: types_1.DayDate.fromNative(end),
        });
    }
    get year() {
        return this._year;
    }
    get weekNumber() {
        return this._weekNumber;
    }
    belongsToThisWeek(date) {
        return this.range.containsInclusive(date);
    }
    equals(other) {
        return this.value === other.value;
    }
    static forDate(day) {
        return new WeekIdentifier(day.year, date_fns_1.getWeek(day.nativeDate, { locale: locale_1.nlBE }));
    }
    static fromWeekIdentifier(id) {
        const split = id.split('-');
        return new WeekIdentifier(parseInt(split[0], 10), parseInt(split[1], 10));
    }
    static get all2021() {
        return [
            new WeekIdentifier(2021, 14),
            new WeekIdentifier(2021, 15),
            new WeekIdentifier(2021, 26),
            new WeekIdentifier(2021, 27),
            new WeekIdentifier(2021, 28),
            new WeekIdentifier(2021, 29),
            new WeekIdentifier(2021, 30),
            new WeekIdentifier(2021, 31),
            new WeekIdentifier(2021, 32),
            new WeekIdentifier(2021, 33),
            new WeekIdentifier(2021, 34),
            new WeekIdentifier(2021, 35),
        ];
    }
    static get all2022() {
        return [
            new WeekIdentifier(2022, 14),
            new WeekIdentifier(2022, 15),
            new WeekIdentifier(2022, 26),
            new WeekIdentifier(2022, 27),
            new WeekIdentifier(2022, 28),
            new WeekIdentifier(2022, 29),
            new WeekIdentifier(2022, 30),
            new WeekIdentifier(2022, 31),
            new WeekIdentifier(2022, 32),
            new WeekIdentifier(2022, 33),
            new WeekIdentifier(2022, 34),
            new WeekIdentifier(2022, 35),
        ];
    }
}
exports.WeekIdentifier = WeekIdentifier;
//# sourceMappingURL=week-identifier.js.map